<mbs-card-group>
  <mbs-form-group>
    <mbs-input
      [attr.data-e2e]="e2eLocators.accountName"
      [boldLabel]="true"
      [formControl]="accountNameControl"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.accountName' | i18next"
      [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.accountName' | i18next"
      [showRequiredMark]="false"></mbs-input>
  </mbs-form-group>
  <mbs-form-group>
    <mbs-input-password
      [attr.data-e2e]="e2eLocators.sharedKey"
      [autocomplete]="'new-password'"
      [boldLabel]="true"
      [disabledEye]="sharedKeyControl.value === fakeSecretKey"
      [formControl]="sharedKeyControl"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.sharedKey' | i18next"
      [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.sharedKey' | i18next"
      [showRequiredMark]="false"></mbs-input-password>
  </mbs-form-group>
  <mbs-form-group>
    <mbs-select
      [attr.data-e2e]="e2eLocators.accountType"
      [bindLabel]="'label'"
      [bindValue]="'value'"
      [boldLabel]="true"
      [formControl]="accountTypeControl"
      [hint]="hint"
      [items]="accountTypes"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.accountType' | i18next"
      [showRequiredMark]="false">
      <ng-template #hint>
        <div [innerHTML]="ServiceEndpointHints?.[accountType] | i18next"></div>
      </ng-template>
    </mbs-select>
  </mbs-form-group>
  <mbs-form-group>
    @if (accountType === AccountType.AzureStack) {
      <mbs-input
        [attr.data-e2e]="e2eLocators.endpoint"
        [boldLabel]="true"
        [formControl]="endpointControl"
        [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.serviceEndpoint' | i18next"
        [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.serviceEndpoint' | i18next"
        [showRequiredMark]="false"></mbs-input>
    } @else {
      <div [attr.data-e2e]="e2eLocators.endpointReadonly">
        <mbs-input-label
          [boldLabel]="true"
          [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.serviceEndpoint' | i18next"></mbs-input-label>

        @if (endpointControl?.value; as endpoint) {
          <mbs-clipboard [content]="endpoint" />
        }
      </div>
    }
  </mbs-form-group>
</mbs-card-group>
